<template>
  <div>
    <div class="ai-btn mb-4 w-100" v-ripple :class="{disabled: !aiExpertEnabled || !chat || chat.length===0}" @click="onNewChat()">
      <img src="@/assets/images/ai-expert/new-chat.svg">Новый чат
    </div>

    <div class="chats-history" :class="{disabled: !aiExpertEnabled}">
      <div class="chats-history-title d-flex justify-space-between align-center" @click="expanded = expandable ? !expanded : expanded">
        <div class="d-flex justify-space-between align-center">
          <img src="@/assets/images/ai-expert/clock.svg" alt="clock" style="margin-right: 8px;" />
          <div>История чатов</div>
        </div>
        <v-icon v-if="expandable" :class="{ rotated: expanded }" small>mdi-chevron-down</v-icon>
      </div>
      <v-expand-transition>
        <div v-if="aiExpertEnabled" v-show="expanded" class="chats-history-list">
          <div v-for="chat in chats" :key="chat.id" class="chats-history-item" v-ripple>
            <v-tooltip bottom v-if="chat.chat_id===curChatId">
              <template v-slot:activator="{ on, attrs }">
                <div class="connect-indicator" :class="{ connected }" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ connected ? 'Есть соединение с AI' : 'Нет соединения с AI'}}</span>
            </v-tooltip>

            <v-tooltip left content-class="custom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <span class="chats-history-item-title" v-bind="attrs" v-on="on" @click="onLoadChat(chat.chat_id)">
                  {{ chat.title }}
                </span>
              </template>
              <span>{{ chat.title }}</span>
            </v-tooltip>

            <v-menu bottom left offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" class="chats-history-item-menubtn">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="confirmRename(chat)">
                  <v-list-item-title>Переименовать</v-list-item-title>
                  <v-list-item-icon><v-icon>mdi-pencil-outline</v-icon></v-list-item-icon>
                </v-list-item>
                <v-list-item @click="confirmDelete(chat)">
                  <v-list-item-title>Удалить</v-list-item-title>
                  <v-list-item-icon><v-icon color="red">mdi-delete-outline</v-icon></v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-menu>

          </div>
        </div>
      </v-expand-transition>
    </div>

    <v-dialog v-model="showRenameDialog" max-width="500">
      <v-card class="pa-4">
        <v-btn class="button-close ma-4" icon @click="showRenameDialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h3 class="mt-4 mb-3 text-center">Переименовать чат</h3>
        <v-card-text>
          <v-text-field v-model="chatTitle" label="Новое название" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" outlined @click="showRenameDialog=false" class="mr-3">Закрыть</v-btn>
          <v-btn color="primary" @click="onRenameChat()" :loading="loading.rename">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AskDialog v-model="showDeleteDialog" @ok="onDelChat()"
      title="Удаление чата"
      text="Вы уверены, что хотите удалить чат? Действие не может быть отменено."
      :loading="loading.delete"
    />
    <AskDialog v-model="showChangeChatDialog" @ok="loadChat(chatId)"
      text="AI-эксперт отвечает на ваше сообщенние. При переходе в другой чат ответ будет потерян."
      textOk="Продолжить"
    />
    <AskDialog v-model="showNewChatDialog" @ok="newChat()"
      text="AI-эксперт отвечает на ваше сообщенние. При переходе в новый чат ответ будет потерян."
      textOk="Продолжить"
    />

  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapState } from 'vuex';
import AskDialog from "@/components/ui/AskDialog"

export default {
  name: 'ChatsHistory',
  components: {
    AskDialog
  },
  props: {
    expandable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showRenameDialog: false,
      showDeleteDialog: false,
      showChangeChatDialog: false,
      showNewChatDialog: false,
      chatId: 0,
      chatTitle: '',
      expanded: true,
    };
  },
  computed: {
    ...mapState('ai/expert', ['chats']),
    ...mapGetters({
      user: 'auth/user',
      chat: 'ai/expert/chat',
      aiExpertEnabled: 'ai/expert/enabled',
      loading: 'ai/expert/loading',
      curChatId: 'ai/expert/curChatId',
      connected: 'ai/expert/connected',
      lastMsgThinking: 'ai/expert/lastMsgThinking',
    }),
  },
  methods: {
    ...mapActions({
      loadChat: 'ai/expert/loadChat',
      setChatName: 'ai/expert/setChatName',
      deleteChat: 'ai/expert/deleteChat',
      newChat: 'ai/expert/newChat',
    }),
    onLoadChat(id) {
      this.chatId = id
      if (this.lastMsgThinking)
        this.showChangeChatDialog = true
      else
        this.loadChat(id)
    },
    onNewChat(id) {
      if (!this.aiExpertEnabled)
        return;
      if (this.lastMsgThinking)
        this.showNewChatDialog = true
      else
        this.newChat()
    },
    confirmRename(chat) {
      this.chatId = chat.chat_id
      this.chatTitle = chat.title
      this.showRenameDialog = true
    },
    confirmDelete(chat) {
      this.chatId = chat.chat_id
      this.chatTitle = chat.title
      this.showDeleteDialog = true
    },
    async onRenameChat() {
      await this.setChatName({ id: this.chatId, title: this.chatTitle })
      this.showRenameDialog = false
    },
    async onDelChat() {
      await this.deleteChat(this.chatId)
      this.showDeleteDialog = false
    }  
  },
  async mounted() {
  },
  beforeDestroy() {}
};
</script>

<style _scoped lang="scss">
@import "src/assets/styles/variables";

.chats-history {
  gap: 8px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05), 2px 0px 4px rgba(0, 0, 0, 0.05), -2px 0px 2px rgba(3, 3, 15, 0.05);
  border-radius: 4px;
  padding-top: 8px;
  // overflow-y: hidden;  

  &-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 10px 12px 16px 12px;
    cursor: pointer;
    user-select: none;    

    .rotated {
      transform: rotate(-90deg);
      transition: transform 0.3s ease;
    }
    .v-icon {
      transition: transform 0.3s ease;
    }    
  }

  &-list {
    overflow-y: auto;  
    height: calc(100vh - 520px - 64px);
    min-height: 270px;
    //min-height: 274px;
  }

  &-item {
    cursor: pointer;
    padding: 10px 2px 10px 12px;
    position: relative;
    &-title {
      display: inline-block;
      width: calc( 100% - 44px );
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      margin-right: 10px;
    }
    &-menubtn {
      display: inline-block;
      width: 30px;
      margin: 0;
      padding: 0;
      opacity: 0.2;
      transition: opacity 0.2s ease;
    }
  }

  &.disabled {
   background: $color-disabled;
   cursor: inherit;
  }  
}

.chats-history-item:hover .chats-history-item-menubtn {
  opacity: 1;
  transition: opacity 0.2s ease;
}


.connect-indicator {
  position: absolute;
  top: 2px;
  left: 0px;
  width: 4px;
  bottom: 2px;
  border-radius: 2px;
  background: rgb(231, 52, 52);
  z-index: 1;
  &.connected {
    background: rgb(114, 236, 114);
  }
}


.custom-tooltip {
  background-color: white !important;
  border: 1px solid #ccc !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2)  !important;
  color: #333 !important;
  padding: 8px 12px !important;
  position: absolute;  
  z-index: 1000;
  white-space: normal;
}

.custom-tooltip::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -7px; 
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #ccc; 
  z-index: 0;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -6px; 
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid white;
  z-index: 1;
}

</style>
